import {Form as RouterForm, useParams} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../store/store.ts';
import {fetchOccasions, occasionSelector} from '../../../store/slices/occasions_slice.ts';
import mainStyles from '../../../components/main/main.module.scss';
import {Main} from '../../../components/main/main.tsx';
import styles from './occasion_modal.module.scss';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {Button} from '../../../components/button/button.tsx';
import {ButtonPosition} from '../../../enums/button_position.ts';
import {__, transString} from '../../../support/lang/translations.ts';
import {Form} from '../../../components/form/form.tsx';
import {FormGrid} from '../../../components/form/form_grid.tsx';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending.ts';
import {Switch} from '../../../components/switch/switch.tsx';
import {useEffect, useState} from 'react';
import {FormFooter} from '../../../components/form_footer/form_footer.tsx';
import {CustomerDataForm} from './partials/customer_data.tsx';
import {OccasionData} from './partials/occasion_data.tsx';

export function OccasionOfferForm() {
    const dispatch = useAppDispatch();
    const params = useParams<'occasionId'>();
    const occasionId = parseInt(params.occasionId ?? '-1', 10);
    const occasion = useAppSelector((state) => occasionSelector(state, occasionId));
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);

    const meData = useAppSelector((state) => state.customerInfo.me?.customer);

    const [tradeIn, setTradeIn] = useState(false);
    const url = window.location.href.replace('/offer', '');

    useEffect(() => {
        dispatch(fetchOccasions());
    }, []);

    if (!occasion) {
        return null;
    }

    return (
        <Main className={mainStyles.bg_white}>
            <div className={styles.occasion_modal}>
                <nav className={styles.occasion_modal__nav}>
                    <div className={styles.title__buttons}>
                        <FlexRow>
                            <FlexColumn alignment={Alignment.Start}>
                                <Button
                                    to={`/occasion/${occasion?.id}`}
                                    position={ButtonPosition.Right}
                                    noBorder={true}
                                    preventScrollReset={true}
                                >
                                    <i className="fa-light fa-chevron-left" />
                                    {__('occasions.details.buttons.back_to_occasion')}
                                </Button>
                            </FlexColumn>
                        </FlexRow>
                    </div>
                </nav>
                <div className={styles.occasion_modal__title}>
                    <div className={styles.title__wrapper}>
                        <FlexRow>
                            <h2>
                                {__('occasions.details.leads.titles.request', {
                                    type: transString(`occasions.details.leads.types.offer`),
                                })}
                            </h2>
                        </FlexRow>
                    </div>
                </div>
                <div className={styles.occasion_modal__subtitle}>
                    <h3>{__('occasions.details.leads.titles.offer_trade_vehicle_in')}</h3>
                </div>
                <RouterForm method="post">
                    <div className={styles.occasion_modal__content}>
                        <div className={styles.occasion_modal__form}>
                            <Form>
                                <input type="hidden" name="occasion_id" value={occasionId} />
                                <input
                                    type="hidden"
                                    name="occasion_name"
                                    value={`${occasion.brand} ${occasion.model} ${occasion.type}`}
                                />
                                <input type="hidden" name="occasion_identifier" value={occasion.numberplate ?? ''} />
                                <input type="hidden" name="url" value={url} />
                                <Switch
                                    disabled={isLoading}
                                    defaultChecked={tradeIn}
                                    onChange={() => setTradeIn(!tradeIn)}
                                    name="tradein"
                                    label={transString('occasions.details.leads.labels.trade_vehicle_in')}
                                />
                                <FormGrid custom={true}>
                                    {tradeIn && (
                                        <>
                                            <input
                                                data-grid-column-start={1}
                                                data-grid-column-end={7}
                                                defaultValue={''}
                                                placeholder={transString('occasions.details.leads.license_plate')}
                                                name={'license_plate'}
                                                required={tradeIn}
                                                disabled={isLoading}
                                            />
                                            <input
                                                data-grid-column-start={7}
                                                data-grid-column-end={13}
                                                defaultValue={''}
                                                placeholder={transString('occasions.details.leads.mileage')}
                                                name={'mileage'}
                                                required={tradeIn}
                                                disabled={isLoading}
                                            />
                                            <textarea
                                                data-grid-column-start={1}
                                                data-grid-column-end={13}
                                                defaultValue={''}
                                                rows={10}
                                                placeholder={transString('occasions.details.leads.remarks')}
                                                name={'remarks'}
                                                required={false}
                                                disabled={isLoading}
                                            />
                                        </>
                                    )}
                                </FormGrid>
                                <div className={styles.occasion_modal__subtitle}>
                                    <h3>{__('occasions.details.leads.titles.customer_data')}</h3>
                                </div>
                                <CustomerDataForm meData={meData} isLoading={isLoading} />
                            </Form>
                        </div>
                        <div className={styles.occasion_modal__overview}>
                            <OccasionData occasion={occasion} />
                        </div>
                    </div>
                    <div className={styles.occasion_modal__footer}>
                        <FormFooter gray={true}>
                            <Button disabled={isLoading} loading={isLoading} position={ButtonPosition.Right}>
                                <i className={isLoading ? 'fa-light fa-refresh' : 'fa-light fa-paper-plane'} />
                                <span>{__('occasions.details.buttons.offer')}</span>
                            </Button>
                        </FormFooter>
                    </div>
                </RouterForm>
            </div>
        </Main>
    );
}
